export const truncate = (text: string = "", number?: number) => {
  return text?.length > 100
    ? text.slice(0, number ? number : 100) + "..."
    : text;
};
